// extracted by mini-css-extract-plugin
export var offlineNotificaton = "fb_Kc";
export var offlineNotificaton__button = "fb_Kg";
export var offlineNotificaton__header = "fb_Kf";
export var offlineNotificaton__text = "fb_Kh";
export var offlineNotificaton__withCookie = "fb_Kd";